import React from 'react';
import styled from 'styled-components';
import Cross from '@assets/images/cross.svg'; 

const ImgWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 92px;
  margin-top: ${props => props.marginTop || 0}; 
  margin-left: ${props => props.marginLeft || 0}; 
  margin-right: ${props => props.marginRight || 0}; 
  margin-bottom: ${props => props.marginBottom || 0}; 
`; 

const CrossImg = styled(Cross)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;


export const IncorrectImg = (props) => {
    return (
      <ImgWrapper {...props}>
        <CrossImg/>
        {props.children}
     </ImgWrapper>
  );
};
